import React, { Component } from 'react';

import MarkdownText from './MarkdownText';
import Section from './Section';
import StatsTable from './StatsTable';
import codeStats from '../data/code-stats';
import miscData from '../data/misc';

import './App.css';
import footerImage from './img/otto-footer.jpg';

const YEARS = [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017];

const scrollToHash = (hash = '') => {
  const id = hash.replace('#', '');
  if (id) {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView();
  }
};

export default class App extends Component {
  componentDidMount() {
    // Scroll to an element on page load.
    scrollToHash(window.location.hash);

    window.addEventListener('hashchange', () => {
      scrollToHash(window.location.hash);
    });

    const selector = 'a[href^="#"]:not([href="#"])';
    [...document.querySelectorAll(selector)].forEach(a => {
      a.addEventListener('click', () => scrollToHash(a.hash));
    });
  }

  render() {
    const totalStats = YEARS.reduce((acc, year) => {
      Object.keys(codeStats[year]).forEach(key => {
        acc[key] += codeStats[year][key];
      });

      return acc;
    }, {
      commits: 0,
      additions: 0,
      deletions: 0,
      prs: 0,
      numRepos: 0,
    });

    return (
      <div className="App" id="top">
        <h1 className="App__header">7 Years at Inkling</h1>
        <div className="App__intro">
          <MarkdownText text={miscData.introduction} />
        </div>
        <div className="App__nav">
          <h3 className="App__nav-header">Jump to a particular year:</h3>
          <div className="App__nav-group-wrapper">
            <ol className="App__nav-group">
              {YEARS.slice(0, 4).map(year => (
                <li key={year} className="App__nav-entry">
                  <a className="App__nav-link" href={`#${year}`}>{year}</a>
                </li>
              ))}
            </ol>
            <ol className="App__nav-group">
              {YEARS.slice(4, 8).map(year => (
                <li key={year} className="App__nav-entry">
                  <a className="App__nav-link" href={`#${year}`}>{year}</a>
                </li>
              ))}
            </ol>
          </div>
          <p className="App__nav-summary">or to my <a href="#final-thoughts">final thoughts</a>.</p>
        </div>
        <div className="App__sections">
          {YEARS.map(year => (
            <Section key={year} year={year} />
          ))}
        </div>
        <div className="App__closing" id="final-thoughts">
          <MarkdownText text={miscData.closing} />
        </div>
        <div className="App__summary">
          <h4 className="App__summary-header">7 years, 4 months, 12 days by the numbers:</h4>
          <div className="App__summary-table">
            <StatsTable
              rows={[
                { name: 'Jira Tickets Opened', value: miscData.stats.jiraTicketsCreated },
                { name: 'Meetings Attended', value: miscData.stats.meetingsAttended },
                { name: 'Emails Sent', value: miscData.stats.emailsSent },
                { name: 'Slack Messages Sent', value: miscData.stats.slackMessagesSent, spaceAfter: true },

                { name: 'Pull Requests Opened', value: totalStats.prs },
                { name: 'Pull Requests Reviewed', value: miscData.stats.prReviews },
                { name: 'Pull Request Comments', value: miscData.stats.prComments, spaceAfter: true },

                { name: 'Repos Touched', value: totalStats.numRepos },
                { name: 'Commits', value: totalStats.commits },
                { name: 'Lines Removed', value: totalStats.deletions },
                { name: 'Lines Added', value: totalStats.additions },
              ]}
              showZeros
            />
          </div>
        </div>
        <footer className="App__footer">
          <img
            className="App__footer-image"
            alt="One more Otto for the road"
            src={footerImage}
          />
        </footer>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js